import React from "react";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import StyleOutlinedIcon from "@mui/icons-material/StyleOutlined";
import DrawerListItem from "../Components/DrawerListItem";

import withAuth from "../../../Hoc/withAuth";

const GlobalDrawerItems = () => {
  return (
    <>
      <DrawerListItem name="Events" path="Events" Icon={EventNoteOutlinedIcon} />
      <DrawerListItem
        name="Organisations"
        path="orgs"
        Icon={LocationCityOutlinedIcon}
      />
      <DrawerListItem name="Causes" path="CausesList" Icon={StyleOutlinedIcon} />
    </>
  );
};

export default withAuth(GlobalDrawerItems);
